import { apiDelete, apiGet, apiPost, apiPut } from './api-service';
import { getUserDetails } from './session-service';

export async function getAll() {
    try {
        const response = await apiGet('core', `risk-task-category`);
        return response;
    } catch (e) { }
}

export async function getRiskTaskCategory(id?: string) {
    try {
        const response = await apiGet('core', `risk-task-category/${id}`);
        return response.content;
    } catch (e) {
        return {};
    }
}


export async function addRiskTaskCategory(newDetails: any) {
    try {
        const response = await apiPost('core', `risk-task-category`, newDetails);
        return response;
    } catch (e) { }
}

export async function updateRiskTaskCategory(id: string, newDetails: any) {
    try {
        const response = await apiPut('core', `risk-task-category/${id}`, newDetails);

        return response.content;
    } catch (e) { }
}

export async function removeRiskTaskCategory(id: any) {
    try {
        return await apiDelete('core', `risk-task-category/${id}`);
    } catch (e) { }
}